import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

const ElagageArbres = () => {
  // Initialiser Google Ads
  useEffect(() => {
    if (window.gtag) {
      window.gtag('config', 'AW-16912204930');
    }
  }, []);

  return (
    <div className="page-container">
      <Helmet>
        <title>Élagage arbre en Île-de-France | Intervention rapide</title>
        <meta
          name="description"
          content="Élagage et abattage d’arbres en Île-de-France. Travail soigné, sécurisé et adapté à vos besoins. Demandez votre devis gratuit."
        />
      </Helmet>
      <div className="page-content">
        <div className="section-header">
          <div className="section-badge">Élagage d'arbres</div>
          <h1 className="page-title">Élagage d'arbres</h1>
        </div>

        {/* Main Image Section - Two Images Side by Side */}
        <section className="modern-section" style={{padding: '0 0 clamp(2rem, 4vw, 3rem) 0'}}>
          <div style={{
            display: 'flex',
            gap: '1rem',
            width: '100%',
            maxWidth: '1200px',
            margin: '0 auto',
            padding: '0 clamp(1rem, 3vw, 1.8rem)'
          }}>
            {/* Left Image */}
            <div style={{
              flex: '1',
              borderRadius: '16px',
              overflow: 'hidden',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
              aspectRatio: '16/9',
              position: 'relative'
            }}>
              <img 
                src="/imgsection/Elaguage/IMG_6258.webp" 
                alt="Élagage d'arbres" 
                loading="lazy"
                style={{
                  width: '100%',
                  height: '100%',
                  display: 'block',
                  objectFit: 'cover',
                  borderRadius: '16px'
                }}
              />
            </div>
            
            {/* Right Image */}
            <div style={{
              flex: '1',
              borderRadius: '16px',
              overflow: 'hidden',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
              aspectRatio: '16/9',
              position: 'relative'
            }}>
              <img 
                src="/imgsection/Elaguage/IMG_6276.webp" 
                alt="Arbres élagués" 
                loading="lazy"
                style={{
                  width: '100%',
                  height: '100%',
                  display: 'block',
                  objectFit: 'cover',
                  borderRadius: '16px'
                }}
              />
            </div>
          </div>
        </section>

        <div className="modern-section" style={{paddingTop: '2rem'}}>
          <div className="section-container">
            <div className="modern-card" style={{maxWidth: '900px', margin: '0 auto'}}>
              <h2 className="section-title" style={{fontSize: 'clamp(1.5rem, 4vw, 2rem)', marginBottom: '1.25rem'}}>
                Élaguer vos arbres en toute sécurité, sans stress
              </h2>
              <p className="page-text" style={{fontSize: 'clamp(1rem, 2.5vw, 1.125rem)', marginBottom: '1.25rem'}}>
                Un arbre qui devient trop envahissant, des branches dangereuses ou simplement un jardin à entretenir… L’élagage ne s’improvise pas. Entre la sécurité, la santé de l’arbre et le rendu final, chaque intervention demande de la précision.
              </p>
              <p className="page-text" style={{fontSize: 'clamp(1rem, 2.5vw, 1.125rem)', marginBottom: '1.25rem'}}>
                Chez Call Garden, on vous accompagne pour entretenir, tailler ou abattre vos arbres en toute sérénité, avec des solutions adaptées à votre terrain et à vos besoins.
              </p>
              <p className="page-text" style={{fontSize: 'clamp(1rem, 2.5vw, 1.125rem)', marginBottom: '2rem'}}>
                L’élagage d’arbre ne se limite pas à couper quelques branches. C’est une intervention technique qui vise à : préserver la santé de l’arbre, sécuriser votre environnement, améliorer l’esthétique de votre jardin, limiter l’ombre ou les nuisances.
              </p>
              <p className="page-text" style={{fontSize: 'clamp(1rem, 2.5vw, 1.125rem)', marginBottom: '2rem'}}>
                Que vous soyez particulier ou professionnel en Île-de-France, ce service s’adresse à tous ceux qui souhaitent un extérieur propre, sécurisé et agréable à vivre.
              </p>
              <p className="page-text" style={{fontSize: 'clamp(1rem, 2.5vw, 1.125rem)', marginBottom: '2rem'}}>
                Nous intervenons aussi bien pour un entretien régulier que pour des situations plus urgentes, comme un arbre fragilisé ou dangereux.
              </p>

              <h2 className="section-title" style={{fontSize: 'clamp(1.5rem, 4vw, 2rem)', marginTop: '2.25rem', marginBottom: '1.25rem'}}>
                Pourquoi choisir Call Garden
              </h2>
              <p className="page-text" style={{fontSize: 'clamp(1rem, 2.5vw, 1.125rem)', marginBottom: '1.25rem'}}>
                Faire appel à un professionnel, ce n’est pas juste gagner du temps. C’est surtout éviter les erreurs coûteuses.
              </p>
              <p className="page-text" style={{fontSize: 'clamp(1rem, 2.5vw, 1.125rem)', marginBottom: '1.25rem'}}>
                Chez Call Garden, on mise sur du concret :
              </p>
              <ul style={{margin: 0, paddingLeft: '1.25rem', marginBottom: '1.5rem'}}>
                <li>Une vraie expérience terrain sur tous types d’arbres</li>
                <li>Des interventions sécurisées, même en zones complexes</li>
                <li>Un matériel professionnel adapté à chaque situation</li>
                <li>Des conseils honnêtes, sans pousser à des travaux inutiles</li>
                <li>Un respect total de votre jardin et des alentours</li>
              </ul>
              <p className="page-text" style={{fontSize: 'clamp(1rem, 2.5vw, 1.125rem)', marginBottom: '0.5rem'}}>
                Chaque arbre est différent. On prend le temps d’analyser avant d’agir.
              </p>

              <div style={{marginTop: '3rem', textAlign: 'center'}}>
                <Link to="/contact" className="modern-button">
                  <span>Demander un devis</span>
                  <svg width="20" height="20" viewBox="0 0 512 512" fill="currentColor">
                    <path d="M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm-28.9 143.6l75.5 72.4H120c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h182.6l-75.5 72.4c-9.7 9.3-9.9 24.8-.4 34.3l11 10.9c9.4 9.4 24.6 9.4 33.9 0L404.3 273c9.4-9.4 9.4-24.6 0-33.9L271.6 106.3c-9.4-9.4-24.6-9.4-33.9 0l-11 10.9c-9.5 9.6-9.3 25.1.4 34.4z"></path>
                  </svg>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ElagageArbres;
